export const data = [
    {
      name: "CMC RA",
      icon: "/reporting.png",
      description:
        "CMC Regulatory Affairs is an AI-powered platform that automates CMC regulatory documentation workflows.",
      link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7B691C3EC1-624A-4A71-9401-331360929EE9%7D&file=CMC-RA.pptx&action=edit&mobileredirect=true",
      btntxt: "Try it Out",
      link2: "https://cmc-ra.usefulbi.com/",
      fontSize: "0.9rem",
      imgwidth: "100px",
      imgheight: "100px",
      tag: ["Gen AI", "Regulatory Affairs", "Document Automation", "Lifesciences", "CMC"],
      type: "usecase",
    },
    {
      name: "HA-RTQ",
      icon: process.env.PUBLIC_URL + "/Chatbot_1.png",
      description:
        "HA-RTQ is an AI-powered assistant that helps regulatory teams quickly and accurately respond to Health Authority queries.",
      link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7BF9331247-0557-444E-8801-80074A5E863D%7D&file=HA-RTQ.pptx&action=edit&mobileredirect=true",
      btntxt: "Try it Out",
      link2: "https://ha-rtq.usefulbi.com/",
      fontSize: "0.9rem",
      imgwidth: "100px",
      imgheight: "100px",
      tag: ["Gen AI", "Regulatory Affairs", "Lifesciences", "Health Authority"],
      type: "usecase",
    },
    {
      name: "UBI Content Generator",
      icon: process.env.PUBLIC_URL + "/AWS.png",
      description:
            "A unified AI platform for generating regulatory-ready Clinical Study Reports with built-in quality checks, traceability, and human review.",
        link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7B856D8D23-7326-4619-801F-4D37066A957A%7D&file=UBI-Reg-Gen%20(CSR).pptx&action=edit&mobileredirect=true&xsdata=MDV8MDJ8fGZmOTQ3YmUzZmM3NzRiODExZTRiMDhkZTRkYjBmYTFhfDUyZmRjY2ZkOTc1MTQ1MWFiMzRmOWQzYmU4ZjQxYmU3fDB8MHw2MzkwMzM2MTk2Mzg3ODc2NTl8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pFME9EUmlNV1ppTFdaaFptUXROR1F6TUMwNE16TmhMVEExWm1VMVlUZGlNVFF3TkY4MFl6UXpObVEzTXkwNE5Ua3dMVFF5TUdZdE9XSmpaQzB3TW1KbE1USTNaRFEwT0dGQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjMk56YzJOVEE1TkRFNU5BPT18OTBiMjk1MzFkZTg2NDY0Njk4YjIwOGRlNGRiMGZhMTl8ZmM1MjIwZmE2ZGU4NDA2YmE4ZDZmNWI5YzFlOWM3MDc%3D&sdata=SjhTS2t0dTE5TTc0MGVoQjFoOXBmb0NnSFBzQStodGFTU0hNby95N0RXZz0%3D&ovuser=52fdccfd-9751-451a-b34f-9d3be8f41be7%2CRishabh%40usefulbi.com",
        btntxt: "Try it Out",
        link2: "https://reg-gen.usefulbi.com/",
        fontSize: "0.9rem",
        imgwidth: "100px",
        imgheight: "100px",
        tag: ["Gen AI", "Regulatory Writing", "Lifesciences", "Automation"],
        type: "usecase",
        }
  ];